import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "terms-and-conditions" }
const _hoisted_2 = { class: "section-title large" }
const _hoisted_3 = { class: "subtitle" }
const _hoisted_4 = { class: "terms-content" }
const _hoisted_5 = { class: "content-section intro-section" }
const _hoisted_6 = { class: "section-badge" }
const _hoisted_7 = { class: "intro-text" }
const _hoisted_8 = { class: "content-section" }
const _hoisted_9 = { class: "section-badge" }
const _hoisted_10 = { class: "markets-grid" }
const _hoisted_11 = { class: "market-card-header" }
const _hoisted_12 = { class: "market-icon" }
const _hoisted_13 = { class: "market-title" }
const _hoisted_14 = { class: "market-content" }
const _hoisted_15 = { class: "market-name" }
const _hoisted_16 = {
  key: 0,
  class: "market-description"
}
const _hoisted_17 = {
  key: 1,
  class: "market-description"
}
const _hoisted_18 = { class: "content-section rules-section" }
const _hoisted_19 = { class: "section-badge" }
const _hoisted_20 = { class: "rules-list" }
const _hoisted_21 = { class: "rule-number" }
const _hoisted_22 = { class: "rule-content" }
const _hoisted_23 = { class: "rule-title" }



type MarketEntry = {
  key: string
  icon: string
  title: string
  name: string
  desc: string
  colorList?: boolean
}


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'TermsAndConditionsView',
},
  __name: 'TermsAndConditionsView',
  setup(__props) {



const markets: MarketEntry[] = [
  { key: 'sumOddEven', icon: '📊', title: 'sumOddEven', name: 'sumOddEvenName', desc: 'sumOddEvenDesc' },
  { key: 'sumOverUnder', icon: '⚖️', title: 'sumOverUnder', name: 'sumOverUnderName', desc: 'sumOverUnderDesc' },
  { key: 'sumWithinRange', icon: '🎯', title: 'sumWithinRange', name: 'sumWithinRangeName', desc: 'sumWithinRangeDesc' },
  { key: 'bonusBallOddEven', icon: '⭐', title: 'bonusBallOddEven', name: 'bonusBallOddEvenName', desc: 'bonusBallOddEvenDesc' },
  { key: 'sumBonusBallsOddEven', icon: '✨', title: 'sumBonusBallsOddEven', name: 'sumBonusBallsOddEvenName', desc: 'sumBonusBallsOddEvenDesc' },
  { key: 'bonusBallOverUnder', icon: '📈', title: 'bonusBallOverUnder', name: 'bonusBallOverUnderName', desc: 'bonusBallOverUnderDesc' },
  { key: 'sumBonusBallsOverUnder', icon: '📉', title: 'sumBonusBallsOverUnder', name: 'sumBonusBallsOverUnderName', desc: 'sumBonusBallsOverUnderDesc' },
  { key: 'bonusBallSingleDigit', icon: '🔢', title: 'bonusBallSingleDigit', name: 'bonusBallSingleDigitName', desc: 'bonusBallSingleDigitDesc' },
  { key: 'bonusBallMatchesRegular', icon: '🔗', title: 'bonusBallMatchesRegular', name: 'bonusBallMatchesRegularName', desc: 'bonusBallMatchesRegularDesc' },
  { key: 'bonusBallWithinRange', icon: '🎲', title: 'bonusBallWithinRange', name: 'bonusBallWithinRangeName', desc: 'bonusBallWithinRangeDesc' },
  { key: 'combinedTotalOverUnder', icon: '➕', title: 'combinedTotalOverUnder', name: 'combinedTotalOverUnderName', desc: 'combinedTotalOverUnderDesc' },
  { key: 'standardBetNoBonus', icon: '🎯', title: 'standardBetNoBonus', name: 'standardBetNoBonusName', desc: 'standardBetNoBonusDesc' },
  { key: 'standardBetSameDrum', icon: '⭐', title: 'standardBetSameDrum', name: 'standardBetSameDrumName', desc: 'standardBetSameDrumDesc' },
  { key: 'standardBetAdditionalDrum', icon: '🎪', title: 'standardBetAdditionalDrum', name: 'standardBetAdditionalDrumName', desc: 'standardBetAdditionalDrumDesc' },
  { key: 'bonusBetSameDrum', icon: '🎲', title: 'bonusBetSameDrum', name: 'bonusBetSameDrumName', desc: 'bonusBetSameDrumDesc' },
  { key: 'bonusBetDifferentDrum', icon: '🎰', title: 'bonusBetDifferentDrum', name: 'bonusBetDifferentDrumName', desc: 'bonusBetDifferentDrumDesc' },
  { key: 'regularPlusBonusSameDrum', icon: '🎯', title: 'regularPlusBonusSameDrum', name: 'regularPlusBonusSameDrumName', desc: 'regularPlusBonusSameDrumDesc' },
  { key: 'ballNotToFall', icon: '🎪', title: 'ballNotToFall', name: 'ballNotToFallName', desc: 'ballNotToFallDesc' },
  { key: 'bonusBallColor', icon: '📊', title: 'bonusBallColor', name: 'bonusBallColorName', desc: 'bonusBallColorDescIntro', colorList: true },
]

const bonusColorKeys = [
  'bonusBallColorListGreen',
  'bonusBallColorListRed',
  'bonusBallColorListOrange',
  'bonusBallColorListYellow',
  'bonusBallColorListBrown',
  'bonusBallColorListPurple',
  'bonusBallColorListBlue',
]

const rules = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t('terms.title')), 1),
    _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('terms.subtitle')), 1),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("section", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('terms.aboutNumbersBetting')), 1),
        _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t('terms.introText')), 1)
      ]),
      _createElementVNode("section", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('terms.availableMarkets')), 1),
        _createElementVNode("div", _hoisted_10, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(markets, (market) => {
            return _createElementVNode("div", {
              key: market.key,
              class: "market-card"
            }, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("span", _hoisted_12, _toDisplayString(market.icon), 1),
                _createElementVNode("h3", _hoisted_13, _toDisplayString(_ctx.$t(`terms.${market.title}`)), 1)
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.$t(`terms.${market.name}`)), 1),
                (market.colorList)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createElementVNode("p", null, _toDisplayString(_ctx.$t(`terms.${market.desc}`)), 1),
                      _createElementVNode("ul", null, [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(bonusColorKeys, (colorKey) => {
                          return _createElementVNode("li", { key: colorKey }, _toDisplayString(_ctx.$t(`terms.${colorKey}`)), 1)
                        }), 64))
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(_ctx.$t(`terms.${market.desc}`)), 1))
              ])
            ])
          }), 64))
        ])
      ]),
      _createElementVNode("section", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t('terms.importantRules')), 1),
        _createElementVNode("div", _hoisted_20, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(rules, (ruleNumber) => {
            return _createElementVNode("div", {
              key: ruleNumber,
              class: "rule-card"
            }, [
              _createElementVNode("div", _hoisted_21, _toDisplayString(ruleNumber), 1),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("h4", _hoisted_23, _toDisplayString(_ctx.$t(`terms.rule${ruleNumber}Title`)), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.$t(`terms.rule${ruleNumber}Text`)), 1)
              ])
            ])
          }), 64))
        ])
      ])
    ])
  ]))
}
}

})